<template>
  <div id="brand-logos" class="fill-height align-start">
    <v-row class="g-container" no-gutters>
      <flewid-dialog
        draggable
        scrollable
        persistent
        content-class="i-dialog"
        v-model="mainLogoAdditionalInfo"
        width="500"
      >
        <v-card>
          <template>
            <v-card-title class="i-dialog-header-div">
              <span class="g-heading-m g-bold">Main Logo</span>
            </v-card-title>

            <v-card-text class="i-dialog-content-div py-4">
              <p class="g-bold g-heading-s">ADDITIONAL INFORMATION</p>
              <div>
                <ul>
                  <li>The image must be a professional logo of the Supplier</li>
                  <li>The image needs to be in-focus and professionally lit</li>
                  <li>The image needs to contain realistic colours</li>
                  <li>
                    The image can't contain additional objects that are
                    confusing
                  </li>
                  <li>The image can't contain unnecessary graphics or text</li>
                  <li>The image must have smooth edges (not jagged edges)</li>
                  <li>
                    The image can't feature any sort of designs, including
                    watermarks, on the images
                  </li>
                </ul>
              </div>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions class="i-dialog-actions-div">
              <v-spacer></v-spacer>
              <v-btn
                text
                rounded
                class="i-btn-text-secondary mr-2"
                @click="mainLogoAdditionalInfo = false"
              >
                Close
              </v-btn>
            </v-card-actions>
          </template>
        </v-card>
      </flewid-dialog>

      <flewid-dialog
        draggable
        scrollable
        persistent
        content-class="i-dialog"
        v-model="brandLogoAdditionalInfo"
        width="500"
      >
        <v-card>
          <template>
            <v-card-title class="i-dialog-header-div">
              <span class="g-heading-m g-bold">Brand Logo Specifications</span>
            </v-card-title>

            <v-card-text class="i-dialog-content-div py-4">
              <div>
                <ul>
                  <li>Max. file size: <strong>1MB</strong></li>
                  <li>
                    JPEG (.JPEG/.JPG), PNG (.PNG), WEBP (.WEBP), OR AVIF (.AVIF)
                    format
                  </li>
                  <li>
                    Pixel dimensions: <strong>500px</strong> wide and
                    <strong>281px</strong> height
                  </li>
                  <li>
                    Pure white background (Not transparent), e.g. RGB (255, 255,
                    255)
                  </li>
                  <li>
                    Full product fills <strong>85%</strong> of the frame with
                    minimal white background to maximise the image size. See
                    example below:
                    <ul>
                      <li>the green frame is the image boundary</li>
                      <li>the blue frame represents 85%</li>
                    </ul>
                  </li>
                </ul>
              </div>

              <p class="g-bold g-heading-s mt-6 mb-4">ADDITIONAL INFORMATION</p>
              <div>
                <ul>
                  <li>The image must be a professional logo of the Brand</li>
                  <li>The image needs to be in-focus and professionally lit</li>
                  <li>The image needs to contain realistic colours</li>
                  <li>
                    The image can't contain additional objects that are
                    confusing
                  </li>
                  <li>The image can't contain unnecessary graphics or text</li>
                  <li>The image must have smooth edges (not jagged edges)</li>
                  <li>
                    The image can't feature any sort of designs, including
                    watermarks, on the images
                  </li>
                </ul>
              </div>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions class="i-dialog-actions-div">
              <v-spacer></v-spacer>
              <v-btn
                text
                rounded
                class="i-btn-text-secondary mr-2"
                @click="brandLogoAdditionalInfo = false"
              >
                Close
              </v-btn>
            </v-card-actions>
          </template>
        </v-card>
      </flewid-dialog>

      <v-col cols="12">
        <h2 class="ma-0">{{ $route.meta.title }}</h2>

        <v-card class="my-4 mb-md-8 pa-4 px-md-6">
          <v-row class="align-center" no-gutters>
            <v-spacer></v-spacer>
            <v-col cols="12" md="3" lg="2">
              <i-instructions
                instructionKey="data-maintenance/brand-logos/main-logo"
              ></i-instructions>
            </v-col>
          </v-row>

          <v-row align="center" justify="space-between">
            <v-col cols="12" md="7">
              <v-card class="supplier-logo-card">
                <p class="g-heading-m g-bold">Supplier Logo</p>
                <v-row>
                  <v-col
                    cols="12"
                    md="6"
                    class="d-flex align-center justify-center"
                  >
                    <div>
                      <input
                        accept="image/x-png,image/png,image/jpeg,image/webp,image/avif,.png,.jpg,.jpeg,.webp,.avif"
                        id="logo-input"
                        ref="mainFileUpload"
                        style="display: none"
                        type="file"
                        @change="addNewLogo"
                      />
                      <v-card class="p-logo-card">
                        <v-img
                          contain
                          width="100%"
                          height="100%"
                          :src="logoUrl"
                          @error="handleLogoError"
                        ></v-img>
                        <div
                          :class="{
                            show:
                              $vuetifyDisplay.mdAndDown || !hasLogo || newLogo
                          }"
                          class="p-logo-overlay d-flex flex-column align-center justify-center"
                        >
                          <template v-if="!hasLogo">
                            <label
                              class="p-label-add-image d-flex align-center justify-center"
                              for="logo-input"
                            >
                              <div>
                                <p>
                                  <v-icon class="p-icon"
                                    >mdi-cloud-upload-outline</v-icon
                                  >
                                </p>
                                <p class="g-bold g-heading-s">
                                  Click here to upload logo
                                </p>
                                <br />
                                <p>
                                  Max file size: 1MB<br />
                                  Make sure it follows specifications
                                </p>
                              </div>
                            </label>
                          </template>

                          <template v-else-if="newLogo">
                            <div class="my-2">
                              <v-btn
                                large
                                rounded
                                class="i-btn-block-secondary p-main-logo-button"
                                @click="confirmLogo()"
                                >Confirm</v-btn
                              >
                            </div>
                            <div class="my-2">
                              <v-btn
                                large
                                rounded
                                class="i-btn-block-white p-main-logo-button"
                                @click="resetLogo()"
                                >Cancel</v-btn
                              >
                            </div>
                          </template>

                          <template v-else>
                            <label for="logo-input">
                              <div class="p-div-btn-secondary elevation-1">
                                Update
                              </div>
                            </label>
                          </template>
                        </div>
                      </v-card>
                    </div>
                  </v-col>
                  <v-col cols="12" md="6">
                    <div>
                      <p class="g-heading-s mb-2">Logo Specifications</p>
                      <ul>
                        <li>Max. file size: <strong>1MB</strong></li>
                        <li>
                          JPEG (.JPEG/.JPG), PNG (.PNG), WEBP (.WEBP), OR AVIF
                          (.AVIF) format
                        </li>
                        <li>
                          Pixel dimensions: <strong>500px</strong> wide and
                          <strong>281px</strong> height
                        </li>
                        <li>Logo is 10% spaced towards edges of image</li>
                        <li>Properly centred and with good definition</li>
                        <li>File name up to 200 characters</li>
                        <li>
                          File name allows special characters "space", "_" and
                          "-" only
                        </li>
                        <li>
                          <span
                            class="i-text-link"
                            @click="mainLogoAdditionalInfo = true"
                            >Click to view more information</span
                          >
                        </li>
                      </ul>
                    </div>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
            <v-col cols="12" md="5">
              <v-card class="supplier-description-card">
                <p class="g-heading-m g-bold">Supplier Information</p>
                <br />
                <div>
                  <v-textarea
                    label="Supplier Information (Max 275 characters)"
                    outlined
                    dense
                    counter="275"
                    v-model="supplierDescription"
                    :rules="[charLimitRule]"
                    :disabled="!isSupplierDescriptionEditing"
                    class="supplier-description-textarea"
                    style="height: calc(100% - 90px)"
                  ></v-textarea>
                </div>
                <div class="d-flex justify-end mt-4">
                  <v-btn
                    v-if="!isSupplierDescriptionEditing"
                    large
                    rounded
                    color="primary"
                    @click="editSupplierDescription"
                    >Edit</v-btn
                  >

                  <template v-else>
                    <v-btn
                      large
                      rounded
                      color="secondary"
                      class="mr-2"
                      @click="saveSupplierDescription"
                      >Save</v-btn
                    >
                    <v-btn
                      large
                      rounded
                      outlined
                      color="grey"
                      @click="cancelSupplierDescriptionEdit"
                      >Cancel</v-btn
                    >
                  </template>
                </div>
              </v-card>
            </v-col>
          </v-row>
        </v-card>
        <v-card class="my-4 my-md-8 pa-4 pa-md-6">
          <v-row class="align-top mb-2" no-gutters>
            <v-col cols="12" md="9">
              <p class="g-heading-m g-bold">Add Brand Logos (up to 4)</p>
              <ul class="mb-4 my-md-2">
                <li>
                  Brands can be added for Draft, Upcoming & Live products that
                  are setup with a Brand.
                </li>
                <li>
                  Brand Logo will display in
                  {{ isILR ? 'Customer' : 'Retailer' }} Marketplace when at
                  least one product of the Brand is Live.
                </li>
                <li>
                  <span
                    class="i-text-link"
                    @click="brandLogoAdditionalInfo = true"
                    >Click to view more information</span
                  >
                </li>
              </ul>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="12" md="3" lg="2">
              <i-instructions
                instructionKey="data-maintenance/brand-logos/brand-logos"
              ></i-instructions>
            </v-col>
          </v-row>

          <v-row>
            <v-col
              cols="12"
              sm="6"
              md="3"
              v-for="brand in brands"
              :key="brand.position"
            >
              <v-select
                attach
                dense
                :disabled="!!brand.imageUrl"
                filled
                :items="availableBrandsList"
                label="Select brand"
                outlined
                v-model="brand.name"
              ></v-select>

              <input
                :id="`logo-brand-input-${brand.position}`"
                ref="secondaryFileUploader"
                type="file"
                accept="image/x-png,image/png,image/jpeg,image/webp,image/avif,.png,.jpg,.jpeg,.webp,.avif"
                @change="addNewBrandLogo($event, brand)"
                style="display: none"
                :disabled="!brand.name"
              />
              <v-card class="p-brand-logo-card" :disabled="!brand.name">
                <v-img
                  :src="brand.imageUrl"
                  width="100%"
                  height="100%"
                  contain
                  @error="handleLogoError"
                ></v-img>

                <div
                  :class="{
                    show:
                      $vuetifyDisplay.mdAndDown ||
                      !brand.imageUrl ||
                      !!brand.logoFile
                  }"
                  class="p-logo-overlay d-flex flex-column align-center justify-center"
                >
                  <template v-if="!brand.name">
                    <label
                      class="p-label-add-image d-flex flex-column align-center justify-center"
                      :class="{ 'p-disabled-card': !brand.name }"
                      :for="`logo-brand-input-${brand.position}`"
                    >
                      <div>
                        <p>
                          <v-icon class="p-icon"
                            >mdi-cursor-default-click-outline</v-icon
                          >
                        </p>
                        <p class="g-bold g-heading-s">Select brand first</p>
                      </div>
                    </label>
                  </template>

                  <template v-else-if="!brand.imageUrl">
                    <label
                      class="p-label-add-image d-flex flex-column align-center justify-center"
                      :class="{ 'p-disabled-card': !brand.name }"
                      :for="`logo-brand-input-${brand.position}`"
                    >
                      <div>
                        <p>
                          <v-icon class="p-icon"
                            >mdi-cloud-upload-outline</v-icon
                          >
                        </p>
                        <p class="g-bold g-heading-s">
                          Click here to upload logo
                        </p>
                      </div>
                    </label>
                  </template>

                  <template v-else-if="!!brand.logoFile">
                    <div class="my-2">
                      <v-btn
                        large
                        rounded
                        class="i-btn-block-secondary p-main-logo-button"
                        @click="confirmBrandLogo(brand)"
                        >Confirm</v-btn
                      >
                    </div>
                    <div class="my-2">
                      <v-btn
                        large
                        rounded
                        class="i-btn-block-white p-main-logo-button"
                        @click="resetBrandLogo(brand)"
                        >Cancel</v-btn
                      >
                    </div>
                  </template>

                  <template v-else>
                    <div class="my-2">
                      <label :for="`logo-brand-input-${brand.position}`">
                        <div class="p-div-btn-secondary elevation-1">
                          Update
                        </div>
                      </label>
                    </div>
                    <div class="my-2">
                      <v-btn
                        large
                        rounded
                        class="i-btn-block-red p-main-logo-button"
                        @click="removeBrandLogo(brand)"
                        >Remove</v-btn
                      >
                    </div>
                  </template>
                </div>
              </v-card>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapActions, mapState, mapGetters } from 'vuex'
import { fetchProfile, updateProfile } from '@/services/profile'
import { ImageValidationHelper } from '@/components/helpers/ImageValidationHelper'
import {
  uploadLogo,
  getBrandsList,
  getBrandsImages,
  uploadBrandLogo,
  deleteBrandLogo
} from '@/services/dataMaintenance'
import FlewidDialog from '@/components/FlewidDialog'
import iInstructions from '@/components/Instructions'

let _initialBrands

const MAX_ALLOWED_IMAGE_SIZE = 1000000
const MAX_ALLOWED_IMAGE_NAME_LENGTH = 200

export default {
  components: {
    iInstructions,
    FlewidDialog
  },

  data: () => ({
    newLogo: false,
    logoUrl: '',
    logoFile: undefined,
    logoError: false,
    initialLogoUrl: '',
    mainLogoAdditionalInfo: false,
    brandLogoAdditionalInfo: false,
    brandsList: [],
    brands: [
      { position: 1, imageUrl: '', name: '' },
      { position: 2, imageUrl: '', name: '' },
      { position: 3, imageUrl: '', name: '' },
      { position: 4, imageUrl: '', name: '' }
    ],
    isSupplierDescriptionEditing: false,
    supplierDescription: '',
    initialSupplierDescription: '',
    charLimitRule: (v) =>
      (v || '').length <= 275 || 'Description must be less than 275 characters'
  }),

  computed: {
    ...mapState('preferences', ['selectedSupplierId']),
    ...mapGetters('tenant', ['isILR']),

    availableBrandsList() {
      const selectedBrands = this.brands.map((brand) => brand.name)

      return this.brandsList.map((brand) => ({
        disabled: selectedBrands.includes(brand),
        text: brand,
        value: brand
      }))
    },

    hasLogo() {
      return !!this.logoUrl
    }
  },

  methods: {
    ...mapActions('notifications', ['addNotification']),

    // ***
    // Helper functions
    // ***

    displayErrorNotification(errorMessage) {
      this.addNotification({
        color: 'error',
        text: errorMessage
      })
    },

    // ***
    // Functions related to fetching data
    // ***

    fetchSupplier() {
      fetchProfile(this.selectedSupplierId)
        .then((response) => {
          this.logoUrl = this.initialLogoUrl = response.logoUrl
          this.initialSupplierDescription = response.supplierDescription
            ? response.supplierDescription
            : ''
          this.supplierDescription = this.initialSupplierDescription
        })
        .catch(() => {
          this.addNotification({
            color: 'error',
            text: 'Supplier information could not be loaded. Please try again...'
          })
        })
    },

    fetchBrands() {
      getBrandsList(this.selectedSupplierId).then((response) => {
        this.brandsList = response
      })

      getBrandsImages(this.selectedSupplierId).then((response) => {
        this.brands = this.brands.map((brand) => {
          const item = response.find(
            ({ position }) => brand.position === position
          )
          return item ? { ...item, name: item.brand } : brand
        })

        _initialBrands = _.cloneDeep(this.brands)
      })
    },

    // ***
    // Functions related to image related actions
    // ***

    addNewLogo(event) {
      if (!event?.target?.files || event.target.files.length < 1) return

      const validSize = ImageValidationHelper.isValidImageSize(
        event.target.files[0].size,
        MAX_ALLOWED_IMAGE_SIZE
      )
      const validFormat = ImageValidationHelper.isValidImageFormat(
        event.target.files[0].name
      )
      const validName = ImageValidationHelper.isValidImageName(
        event.target.files[0].name
      )
      const validNameLength = ImageValidationHelper.isValidImageNameLength(
        event.target.files[0].name,
        MAX_ALLOWED_IMAGE_NAME_LENGTH
      )

      if (!validSize)
        this.displayErrorNotification('Image file size is larger than 1MB...')
      else if (!validFormat)
        this.displayErrorNotification(
          'Image file must be in JPEG (.jpeg/.jpg), PNG (.png), WEBP (.webp), or AVIF (.avif) format only...'
        )
      else if (!validName)
        this.displayErrorNotification(
          'Image file name allows special characters "space", "_" and "-" only...'
        )
      else if (!validNameLength)
        this.displayErrorNotification(
          `Image file name can be up to ${MAX_ALLOWED_IMAGE_NAME_LENGTH} characters only...`
        )
      else {
        this.logoFile = event.target.files[0]
        this.logoUrl = URL.createObjectURL(event.target.files[0])
        this.newLogo = true
      }
    },

    addNewBrandLogo(event, brand) {
      if (!event?.target?.files || event.target.files.length < 1) return

      const validSize = ImageValidationHelper.isValidImageSize(
        event.target.files[0].size,
        MAX_ALLOWED_IMAGE_SIZE
      )
      const validFormat = ImageValidationHelper.isValidImageFormat(
        event.target.files[0].name
      )
      const validName = ImageValidationHelper.isValidImageName(
        event.target.files[0].name
      )
      const validNameLength = ImageValidationHelper.isValidImageNameLength(
        event.target.files[0].name,
        MAX_ALLOWED_IMAGE_NAME_LENGTH
      )

      if (!validSize)
        this.displayErrorNotification('Image file size is larger than 1MB...')
      else if (!validFormat)
        this.displayErrorNotification(
          'Image file must be in JPEG (.jpeg/.jpg), PNG (.png), WEBP (.webp), or AVIF (.avif) format only...'
        )
      else if (!validName)
        this.displayErrorNotification(
          'Image file name allows special characters "space", "_" and "-" only...'
        )
      else if (!validNameLength)
        this.displayErrorNotification(
          `Image file name can be up to ${MAX_ALLOWED_IMAGE_NAME_LENGTH} characters only...`
        )
      else {
        brand.logoFile = event.target.files[0]
        brand.imageUrl = URL.createObjectURL(event.target.files[0])
      }

      this.$refs.secondaryFileUploader[
        this.brands.findIndex(({ position }) => position === brand.position)
      ].value = ''
    },

    confirmLogo() {
      uploadLogo(this.selectedSupplierId, this.logoFile)
        .then(() => {
          this.newLogo = false
          this.addNotification({
            color: 'secondary',
            text: 'Logo successfully updated'
          })
        })
        .catch(() => {
          this.addNotification({
            color: 'error',
            text: 'Logo could not be updated...'
          })
        })
        .finally(() => {
          this.fetchSupplier()
        })
    },

    confirmBrandLogo(brand) {
      uploadBrandLogo(
        this.selectedSupplierId,
        brand.name,
        brand.position,
        brand.logoFile
      )
        .then(() => {
          this.addNotification({
            color: 'secondary',
            text: 'Brand logo successfully updated'
          })
        })
        .catch(() => {
          this.addNotification({
            color: 'error',
            text: 'Brand logo could not be updated...'
          })
        })
        .finally(() => {
          this.fetchBrands()
        })
    },

    resetLogo() {
      this.logoUrl = this.initialLogoUrl
      this.newLogo = false
      this.$refs.mainFileUpload.value = ''
    },

    resetBrandLogo(brand) {
      Object.assign(
        brand,
        _initialBrands.find(({ position }) => position === brand.position),
        { logoFile: '' }
      )
    },

    removeBrandLogo(brand) {
      deleteBrandLogo(brand.id)
        .then(() => {
          this.addNotification({
            color: 'secondary',
            text: 'Brand logo successfully removed'
          })
          this.brands[
            this.brands.findIndex(({ position }) => position === brand.position)
          ] = { position: brand.position, imageUrl: '', name: '' }
        })
        .catch(() => {
          this.addNotification({
            color: 'error',
            text: 'Brand logo could not be removed...'
          })
        })
        .finally(() => {
          this.fetchBrands()
        })
    },

    handleLogoError() {
      this.logoError = true
    },

    editSupplierDescription() {
      this.isSupplierDescriptionEditing = true
    },

    cancelSupplierDescriptionEdit() {
      this.supplierDescription = this.initialSupplierDescription
      this.isSupplierDescriptionEditing = false
    },

    saveSupplierDescription() {
      if (this.supplierDescription.length > 275) {
        this.addNotification({
          color: 'error',
          text: 'Description cannot exceed 275 characters.'
        })
        return
      }
      this.isSupplierDescriptionEditing = false
      const request = {
        supplierDescription: this.supplierDescription
      }
      updateProfile(this.selectedSupplierId, request)
        .then((response) => {
          this.isSupplierDescriptionEditing = false
          this.addNotification({
            color: 'secondary',
            text: 'Updated the Description'
          })
          this.initialSupplierDescription = this.supplierDescription
          fetchProfile(this.selectedSupplierId)
        })
        .catch(() => {
          this.addNotification({
            color: 'error',
            text: 'Information could not be updated...'
          })
        })
        .finally(() => {
          this.isSupplierDescriptionEditing = false
        })
    }
  },

  mounted() {
    this.fetchSupplier()
    this.fetchBrands()
  }
}
</script>

<style lang="scss" scoped>
#brand-logos {
  .p-logo-card {
    background-color: #f8f9fa;
    width: 350px;
    height: 160px;
    max-width: 275px;
    border-radius: 5px;
    border-width: 0px;
    overflow: hidden;
  }
  .p-logo-overlay {
    background-color: rgba(0, 0, 0, 0.6);
    color: white;
    text-align: center;
    opacity: 0;
    position: absolute;
    height: 100%;
    width: 100%;
    top: 0;
    transition: opacity 0.3s ease-in-out;
    &:hover,
    &.show {
      opacity: 1;
    }
  }
  .p-label-add-image {
    width: 100%;
    height: 100%;
    &:hover {
      cursor: pointer;
    }
  }
  .p-main-logo-button,
  .p-div-btn-secondary {
    width: 200px;
  }
  .p-div-btn-secondary {
    background-color: $secondary-color;
    border-radius: 50px;
    color: white;
    font-weight: bold;
    letter-spacing: 0.75px;
    padding: 10px 0px 10px 0px;
    text-align: center;
    &:hover {
      cursor: pointer;
    }
  }
  .p-brand-logo-card {
    background-color: #f8f9fa;
    width: 100%;
    height: 200px;
    max-width: 275px;
    border-radius: 5px;
    border-width: 0px;
    position: relative;
  }
  .p-disabled-card {
    background-color: gray;
  }
  .p-icon {
    width: 64px;
    height: 64px;
    color: white;
  }
  .p-icon:before {
    font-size: 64px;
  }
  .supplier-logo-card {
    min-height: 350px;
    width: 100%;
    padding: 16px;
    border-radius: 8px;
  }
  .supplier-description-card {
    width: 100%;
    height: 420px;
    border-radius: 8px;
    padding: 16px;
  }
}

@media only screen and (max-width: 960px) {
  #brand-logos {
    .p-logo-card {
      max-width: 697px;
      height: 160px;
    }
    .p-brand-logo-card {
      max-width: 697px;
      height: 197px;
    }
    .supplier-logo-card {
      height: 450px;
    }
  }
}
</style>
